export const measurementDatasetFromService = (dataset) => {
    // The report id is what a segment targets, so a row without one is malformed
    // rather than a dataset with a blank field.
    if (!dataset.reportId) {
        throw new Error("measurement dataset is missing its report id");
    }
    return {
        reportId: dataset.reportId,
        name: dataset.name || "",
        description: dataset.description || "",
        advertiserId: dataset.advertiserId || "",
        dmpOrgId: dataset.dmpOrgId || ""
    };
};
//# sourceMappingURL=measurementDataset.js.map